export const makeCachedScheduler = scheduler => {
  const cache = new Map();
  return {
    fetch: input => {
      const key = scheduler.identity(input);
      if (cache.has(key)) {
        return cache.get(key);
      }
      const promise = scheduler.queue(input);
      cache.set(key, promise);
      return promise;
    },
    clearCache: () => {
      cache.clear();
      scheduler.abort();
    }
  };
};